// ── Android search tap fix ────────────────────────────────────────────────────
// The BSS Banner slider calls preventDefault() on touchstart for swipe
// detection. On Android Chrome this suppresses the synthesized click event that
// the theme's jQuery delegated handler relies on (iOS handles this differently).
// We bypass the broken touch→click pipeline by catching touchend directly on
// the search trigger and calling showSearch() ourselves.
(function () {
  function fixSearchTouch() {
    document.addEventListener('touchend', function (e) {
      var trigger = e.target.closest('[data-show-search-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      if (window.PXUTheme && window.PXUTheme.jsHeader) {
        window.PXUTheme.jsHeader.showSearch();
      } else {
        trigger.click();
      }
    }, { passive: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSearchTouch);
  } else {
    fixSearchTouch();
  }
})();

// ── LOK swatch detection ─────────────────────────────────────────────────────
// When LinkedOption King injects <king-linked-options-collection> into a card's
// .mobilehide div, switch that card's button to "Select Options" / quick-view.

function convertCardIfLOK(card) {
  if (!card) return;
  var btn = card.querySelector('.gs-atc-btn.add-to-cart');
  if (!btn) return;
  var lokEl = card.querySelector('king-linked-options-collection');
  if (!lokEl) return;

  var titleEl = card.querySelector('.product-thumbnail__title');
  var title = titleEl ? titleEl.textContent : '';
  var selectColorProducts = /vertical planter|top water reservoir|individual leaf planter|individual original planter|flourish gift bundle|inventor's bundle|greenstalk ultimate mover|greenstalk garden lid|greenstalk seed starter kit with domes/i;
  btn.textContent = selectColorProducts.test(title) ? 'Select Color' : 'Select Options';
  btn.classList.remove('add-to-cart');
  btn.classList.add('js-quick-shop-link');
  btn.removeAttribute('data-variant-id');
  btn.removeAttribute('data-product-id');
  // data-id and data-url are already on the button from the Liquid template
}

// Observe only the direct children of each .mobilehide — where LOK injects.
// Disconnecting immediately after the first mutation keeps this cheap.
function watchCardsForLOK() {
  document.querySelectorAll('.product__grid-item .mobilehide').forEach(function (mobilehide) {
    var card = mobilehide.closest('.product__grid-item');
    // If LOK already injected before we got here, convert immediately
    if (card.querySelector('king-linked-options-collection')) {
      convertCardIfLOK(card);
      return;
    }
    var obs = new MutationObserver(function () {
      convertCardIfLOK(card);
      obs.disconnect();
    });
    obs.observe(mobilehide, { childList: true }); // direct children only, no subtree
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchCardsForLOK);
} else {
  watchCardsForLOK();
}

// ── Collection card AJAX Add to Cart ─────────────────────────────────────────
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gs-atc-btn[data-variant-id]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var variantId = btn.getAttribute('data-variant-id');
  var originalText = btn.textContent.trim();

  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        btn.disabled = false;
        btn.textContent = originalText;
        alert(data.description || 'Could not add to cart.');
        return;
      }

      btn.textContent = 'Added!';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var counters = document.querySelectorAll('.cart-item-count, .js-cart-count, [data-cart-count]');
          counters.forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });

      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = originalText;
      console.error('ATC error:', err);
    });
});
